const service = [
    'SimpleApiFactory',
    '$resource',
    '$rootScope',
];

const fn = (
    SimpleApiFactory,
    $resource,
    $rootScope
) => {
    const F = {};

    F.data = {};

    F.resource = function() {
        return $resource('/api/public/user');
    };

    F.fetch = function() {
        return F.resource().get({}, (response) => {
            const parsedResponse = SimpleApiFactory.parse(response);

            if(!parsedResponse.status) {
                return console.error('Unable to fetch Current User.');
            }

            F.data = response.data || {};

            $rootScope.$emit('CurrentUserFetched');
        }, (body) => {
            console.error('Unable to fetch Current User.', body);
        });
    };

    F.all = function() {
        return angular.copy(F.data);
    };

    F.isLoggedIn = function() {
        return !!Object.keys(F.data).length;
    };

    return F;
};

service.push(fn);

export default service;



// WEBPACK FOOTER //
// ./resources/assets/app-releases/services/UserFactory.js